/* Duplicate arrows for resource lists */
document.addEventListener('DOMContentLoaded', () => {
  const mediaQuery = window.matchMedia('(min-width: 750px)');

  const setups = new WeakMap();

  const cleanupSection = (section) => {
    const saved = setups.get(section);
    if (!saved) return;

    saved.originalArrows.style.display = '';
    saved.clone?.remove();
    saved.observer?.disconnect();

    setups.delete(section);
  };

  const setupSection = (section) => {
    const parent = section.parentElement;
    if (!parent) return;

    const originalArrows = parent.querySelector('slideshow-arrows');
    const arrowWrapper = parent.querySelector('.arrow-wrapper');

    if (!originalArrows || !arrowWrapper) return;

    if (setups.has(section)) return;

    const originalButtons = Array.from(originalArrows.querySelectorAll('button'));
    if (!originalButtons.length) return;

    const clonedArrows = originalArrows.cloneNode(true);
    clonedArrows.setAttribute('data-cloned-slideshow-arrows', '');

    const clonedButtons = Array.from(clonedArrows.querySelectorAll('button'));

    const syncButtons = () => {
      originalButtons.forEach((originalButton, index) => {
        const clonedButton = clonedButtons[index];
        if (!clonedButton) return;

        clonedButton.disabled = originalButton.disabled;

        if (originalButton.disabled) {
          clonedButton.setAttribute('disabled', '');
        } else {
          clonedButton.removeAttribute('disabled');
        }

        clonedButton.setAttribute('aria-disabled', String(originalButton.disabled));

        if (originalButton.className !== clonedButton.className) {
          clonedButton.className = originalButton.className;
        }
      });
    };

    clonedButtons.forEach((clonedButton, index) => {
      clonedButton.addEventListener('click', (event) => {
        event.preventDefault();
        if (originalButtons[index]?.disabled) return;
        originalButtons[index]?.click();
      });
    });

    const observer = new MutationObserver(() => {
      syncButtons();
    });

    originalButtons.forEach((button) => {
      observer.observe(button, {
        attributes: true,
        attributeFilter: ['disabled', 'class', 'aria-disabled']
      });
    });

    originalArrows.style.display = 'none';
    arrowWrapper.appendChild(clonedArrows);
    syncButtons();

    setups.set(section, {
      originalArrows,
      clone: clonedArrows,
      observer
    });
  };

  const updateAll = () => {
    document.querySelectorAll('.section-resource-list').forEach((section) => {
      if (mediaQuery.matches) {
        setupSection(section);
      } else {
        cleanupSection(section);
      }
    });
  };

  updateAll();

  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', updateAll);
  } else {
    mediaQuery.addListener(updateAll);
  }
});

/* Collection description shortening */
document.addEventListener('DOMContentLoaded', function () {
  const mobileBreakpoint = 749;
  const readMoreText = window.themeStrings?.readMore || 'Read more';

  function initCollectionReadMore() {
    const el = document.querySelector('.collection-heading rte-formatter');
    if (!el) return;

    const fullText = (el.dataset.fullText || el.textContent).trim();

    if (!el.dataset.fullText) {
      el.dataset.fullText = fullText;
    }

    if (window.innerWidth <= mobileBreakpoint) {
      if (fullText.length <= 150) return;

      if (el.dataset.truncated === 'true') return;

      const truncatedText = fullText.slice(0, 150).trim() + '...';

      el.innerHTML = `
        <p>
          ${truncatedText}
          <span class="collection-read-more">
            ${readMoreText}
          </span>
        </p>
      `;

      el.dataset.truncated = 'true';

      const btn = el.querySelector('.collection-read-more');
      if (btn) {
        btn.addEventListener('click', function () {
          el.innerHTML = `<p>${fullText}</p>`;
          el.dataset.truncated = 'false';
        });
      }
    } else {
      if (el.dataset.fullText) {
        el.innerHTML = `<p>${el.dataset.fullText}</p>`;
        el.dataset.truncated = 'false';
      }
    }
  }

  initCollectionReadMore();
  window.addEventListener('resize', initCollectionReadMore);
});

/* Move product page elements in mobile */
(function () {
  const mq = window.matchMedia('(max-width: 749px)');
  const headerEl = document.querySelector('.mobile-product-header');
  const breadcrumbEl = document.querySelector('.product-breadcrumb');

  if (!headerEl || !breadcrumbEl) return;

  if (!headerEl.__originalParent) {
    headerEl.__originalParent = headerEl.parentNode;
    headerEl.__originalNext = headerEl.nextSibling;
  }

  function run() {
    if (mq.matches) {
      breadcrumbEl.appendChild(headerEl);
      headerEl.classList.add('show');
    } else {
      const p = headerEl.__originalParent;
      const n = headerEl.__originalNext;

      if (p) {
        if (n && n.parentNode === p) {
          p.insertBefore(headerEl, n);
        } else {
          p.appendChild(headerEl);
        }
      }

      headerEl.classList.remove('show');
    }
  }

  run();
  mq.addEventListener('change', run);
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:select', run);
})();

/* Price slider */
document.addEventListener('DOMContentLoaded', () => {
  function parseNumber(value) {
    if (!value) return 0;
    return parseFloat(String(value).replace(/\./g, '').replace(',', '.').replace(/[^\d.]/g, '')) || 0;
  }

  function initPriceFacet(facet) {
    const minText = facet.querySelector('[ref="minInput"]');
    const maxText = facet.querySelector('[ref="maxInput"]');
    const minRange = facet.querySelector('[ref="minRange"]');
    const maxRange = facet.querySelector('[ref="maxRange"]');
    const progress = facet.querySelector('[ref="rangeProgress"]');

    if (!minText || !maxText || !minRange || !maxRange || !progress) return;

    const minGap = 0;
    const max = parseFloat(maxRange.max) || 0;

    function updateProgress() {
      const min = parseFloat(minRange.value) || 0;
      const maxVal = parseFloat(maxRange.value) || max;

      const leftPercent = (min / max) * 100;
      const rightPercent = 100 - (maxVal / max) * 100;

      progress.style.left = `calc(${leftPercent}% + 12px - (${leftPercent} * 24px / 100))`;
      progress.style.right = `calc(${rightPercent}% + 12px - (${rightPercent} * 24px / 100))`;
    }

    function syncRangesFromText() {
      let minVal = parseNumber(minText.value);
      let maxVal = parseNumber(maxText.value);

      if (!minText.value.trim()) minVal = 0;
      if (!maxText.value.trim()) maxVal = max;

      if (minVal > maxVal - minGap) {
        if (document.activeElement === minText) {
          minVal = maxVal - minGap;
        } else {
          maxVal = minVal + minGap;
        }
      }

      minVal = Math.max(0, Math.min(minVal, max));
      maxVal = Math.max(0, Math.min(maxVal, max));

      minRange.value = minVal;
      maxRange.value = maxVal;
      updateProgress();
    }

    function syncTextFromRanges(changed) {
      let minVal = parseFloat(minRange.value) || 0;
      let maxVal = parseFloat(maxRange.value) || max;

      if (maxVal < minVal + minGap) {
        if (changed === 'min') {
          minVal = maxVal - minGap;
          minRange.value = minVal;
        } else {
          maxVal = minVal + minGap;
          maxRange.value = maxVal;
        }
      }

      minText.value = minVal > 0 ? String(Math.round(minVal)) : '';
      maxText.value = maxVal < max ? String(Math.round(maxVal)) : '';
      updateProgress();
    }

    minRange.addEventListener('input', () => {
      syncTextFromRanges('min');
    });

    maxRange.addEventListener('input', () => {
      syncTextFromRanges('max');
    });

    minRange.addEventListener('change', () => {
      minText.dispatchEvent(new Event('change', { bubbles: true }));
    });

    maxRange.addEventListener('change', () => {
      maxText.dispatchEvent(new Event('change', { bubbles: true }));
    });

    minText.addEventListener('input', syncRangesFromText);
    maxText.addEventListener('input', syncRangesFromText);

    syncRangesFromText();
  }

  document.querySelectorAll('price-facet-component').forEach(initPriceFacet);
});

(() => {
  function paintFacet(facet) {
    if (!facet) return;

    const minRange = facet.querySelector('[ref="minRange"]');
    const maxRange = facet.querySelector('[ref="maxRange"]');
    const progress = facet.querySelector('[ref="rangeProgress"]');

    if (!minRange || !maxRange || !progress) return;

    const max = parseFloat(maxRange.max) || 0;
    if (!max) return;

    const minVal = parseFloat(minRange.value) || 0;
    const maxVal = parseFloat(maxRange.value) || max;

    const leftPercent = (minVal / max) * 100;
    const rightPercent = 100 - (maxVal / max) * 100;

    const left = `calc(${leftPercent}% + 12px - (${leftPercent} * 24px / 100))`;
    const right = `calc(${rightPercent}% + 12px - (${rightPercent} * 24px / 100))`;

    progress.setAttribute('style', `left:${left};right:${right};`);
  }

  function paintAll(root = document) {
    root.querySelectorAll('price-facet-component').forEach(paintFacet);
  }

  function repaintBurst() {
    let frame = 0;
    const maxFrames = 40;

    function tick() {
      paintAll();
      frame += 1;
      if (frame < maxFrames) {
        requestAnimationFrame(tick);
      }
    }

    requestAnimationFrame(tick);
  }

  function delayedRepaint() {
    repaintBurst();
    setTimeout(() => paintAll(), 0);
    setTimeout(() => paintAll(), 50);
    setTimeout(() => paintAll(), 150);
    setTimeout(() => paintAll(), 300);
  }

  document.addEventListener('DOMContentLoaded', () => {
    paintAll();
  });

  document.addEventListener('input', (e) => {
    if (e.target.closest('price-facet-component')) {
      repaintBurst();
    }
  });

  document.addEventListener('change', (e) => {
    if (e.target.closest('price-facet-component')) {
      delayedRepaint();
    }
  });
})();

/* Move free shipping in cart on mobile */
(function () {
  const mq = window.matchMedia('(max-width: 749px)');
  const freeShippingEl = document.querySelector('.cart-summary__meta-item--free-shipping');
  const cartPage = document.querySelector('.cart-page');

  if (!freeShippingEl || !cartPage) return;

  if (!freeShippingEl.__originalParent) {
    freeShippingEl.__originalParent = freeShippingEl.parentNode;
    freeShippingEl.__originalNext = freeShippingEl.nextSibling;
  }

  function run() {
    if (mq.matches) {
      cartPage.prepend(freeShippingEl);
    } else {
      const p = freeShippingEl.__originalParent;
      const n = freeShippingEl.__originalNext;

      if (p) {
        if (n && n.parentNode === p) {
          p.insertBefore(freeShippingEl, n);
        } else {
          p.appendChild(freeShippingEl);
        }
      }
    }
  }

  run();
  mq.addEventListener('change', run);
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:select', run);
})();

/* Update shipping cost from MakeCommerce */
document.addEventListener('DOMContentLoaded', function () {
  function parsePrice(text) {
    if (!text) return 0;

    return (
      parseFloat(
        String(text)
          .replace(',', '.')
          .replace(/[^\d.]/g, '')
      ) || 0
    );
  }

  function formatPrice(value) {
    return value.toFixed(2).replace('.', ',') + ' €';
  }

  function isVisible(el) {
    return !!(el && el.offsetParent !== null);
  }

  function getSelectedCarrier() {
    const activeCarriers = Array.from(
      document.querySelectorAll('.mc-carrier-btn.active')
    );

    return activeCarriers.find(isVisible) || activeCarriers[0] || null;
  }

  function isInternationalCourierActive() {
    return !!document.querySelector(
      '.mc-delivery-btn.active[data-id="international"]'
    );
  }

  function updateShippingPrice() {
    const shippingCostEl = document.querySelector(
      '.cart-summary__meta-value.shipping-cost'
    );

    const totalEl = document.querySelector('.cart-totals__total-value');

    const selectedCarrier = getSelectedCarrier();
    const priceEl = selectedCarrier
      ? selectedCarrier.querySelector('.mc-carrier-price')
      : null;

    let shippingPrice = priceEl ? parsePrice(priceEl.textContent) : 0;

    let baseTotal = totalEl
      ? parsePrice(
          totalEl.dataset.baseTotal ||
            totalEl.getAttribute('data-base-total') ||
            totalEl.getAttribute('value') ||
            totalEl.textContent
        )
      : 0;

    if (totalEl && !totalEl.dataset.baseTotal) {
      totalEl.dataset.baseTotal = baseTotal;
    }

    if (isInternationalCourierActive()) {
      shippingPrice = baseTotal >= 49 ? 0 : 3.99;
    }

    if (shippingCostEl) {
      shippingCostEl.textContent = formatPrice(shippingPrice);
    }

    if (totalEl) {
      totalEl.textContent = formatPrice(baseTotal + shippingPrice);

      if (totalEl.hasAttribute('value')) {
        totalEl.setAttribute('value', formatPrice(baseTotal + shippingPrice));
      }
    }
  }

  function delayedUpdate() {
    setTimeout(updateShippingPrice, 50);
    setTimeout(updateShippingPrice, 150);
  }

  document.addEventListener('click', function (e) {
    if (
      e.target.closest(
        '.mc-carrier-btn, .mc-delivery-btn, .mc-pickup-btn'
      )
    ) {
      delayedUpdate();
    }
  });

  document.addEventListener('change', function (e) {
    if (
      e.target.matches(
        '#mc-country-select, #mk-address-select, .address-select'
      )
    ) {
      delayedUpdate();
    }
  });

  const observer = new MutationObserver(function () {
    updateShippingPrice();
  });

  const shippingWrapper = document.querySelector('#mc-shipping-wrapper');

  if (shippingWrapper) {
    observer.observe(shippingWrapper, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  updateShippingPrice();
});

/* Add to cart pop up */
(function () {
  const toast = document.getElementById('cart-added-toast');
  const closeButton = document.getElementById('cart-added-toast-close');
  const image = document.getElementById('cart-added-toast-image');
  const title = document.getElementById('cart-added-toast-title');
  const price = document.getElementById('cart-added-toast-price');
  const comparePrice = document.getElementById('cart-added-toast-compare-price');

  if (!toast || !closeButton || !image || !title || !price || !comparePrice) return;

  let hideTimeout;

  function hideToast() {
    toast.classList.add('hidden');
    clearTimeout(hideTimeout);
  }

  function showToast(detail) {
    title.textContent = detail.title || '';
    price.textContent = detail.price || '';

    if (detail.comparePrice && detail.comparePrice !== detail.price) {
      comparePrice.textContent = detail.comparePrice;
      comparePrice.classList.remove('hidden');
    } else {
      comparePrice.textContent = '';
      comparePrice.classList.add('hidden');
    }

    if (detail.image) {
      image.src = detail.image;
      image.alt = detail.title || '';
      image.removeAttribute('hidden');
    } else {
      image.src = '';
      image.alt = '';
      image.setAttribute('hidden', 'hidden');
    }

    toast.classList.remove('hidden');

    clearTimeout(hideTimeout);
    hideTimeout = setTimeout(hideToast, 4000);
  }

  closeButton.addEventListener('click', hideToast);
  window.addEventListener('cart:added-toast', (event) => showToast(event.detail || {}));
})();

/* Cart agreement */
(function () {
  const checkbox = document.querySelector('.cart__checkout-checkbox-input');
  const error = document.querySelector('[data-checkout-checkbox-error]');
  const checkoutButtons = document.querySelectorAll('.cart__checkout-button');

  if (!checkbox || !error || !checkoutButtons.length) return;

  checkoutButtons.forEach(function (checkoutButton) {
    checkoutButton.addEventListener('click', function (event) {
      if (checkbox.checked) {
        error.classList.add('hidden');
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      error.classList.remove('hidden');
      checkbox.focus();
    }, true);
  });

  checkbox.addEventListener('change', function () {
    if (checkbox.checked) {
      error.classList.add('hidden');
    }
  });
})();

/* Match review section rating with judgeme */
function updateAvelReviewRating() {
  const reviewTextStrong = document.querySelector('.avel-reviews__text strong');
  const judgeMeWidget = document.querySelector('.jdgm-rev-widg[data-average-rating]');

  if (!reviewTextStrong || !judgeMeWidget) return false;

  const averageRating = judgeMeWidget.getAttribute('data-average-rating');

  if (!averageRating) return false;

  reviewTextStrong.textContent = averageRating;
  return true;
}

document.addEventListener('DOMContentLoaded', () => {
  if (updateAvelReviewRating()) return;

  const reviewsSection =
    document.querySelector('.jdgm-widget') ||
    document.querySelector('.jdgm-rev-widg') ||
    document.querySelector('#judgeme_product_reviews');

  if (!reviewsSection) return;

  const observer = new MutationObserver(() => {
    if (updateAvelReviewRating()) {
      observer.disconnect();
    }
  });

  observer.observe(reviewsSection, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-average-rating'],
  });
});

/* Hide empty product page accordions */
(() => {
  const MEDIA_SELECTOR = 'img, picture, video, iframe, svg, canvas, input, select, textarea, model-viewer';

  const isEmpty = (content) => {
    if (content.querySelector(MEDIA_SELECTOR)) return false;

    const clone = content.cloneNode(true);
    clone.querySelectorAll('script, style, template').forEach((node) => node.remove());

    return clone.textContent.replace(/[\s\u00a0\u200b]+/g, '') === '';
  };

  const update = () => {
    document.querySelectorAll('.product-details accordion-custom').forEach((accordion) => {
      const content = accordion.querySelector('.details-content');
      if (!content) return;

      accordion.style.display = isEmpty(content) ? 'none' : '';
    });
  };

  const observed = new WeakSet();
  let frame = null;

  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(update);
  };

  const init = () => {
    update();

    document.querySelectorAll('.product-details').forEach((root) => {
      if (observed.has(root)) return;
      observed.add(root);

      new MutationObserver(schedule).observe(root, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('variant:update', () => setTimeout(init, 0));
  document.addEventListener('shopify:section:load', init);
})();

/* Avel banner carousel */
(() => {
  const SLIDER_SELECTOR = '.avel-banner-carousel__slider';
  const SWIPER_VERSION = 12;

  const loadSwiper = (callback) => {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }

    if (!document.getElementById('swiper-bundle-css')) {
      const link = document.createElement('link');
      link.id = 'swiper-bundle-css';
      link.rel = 'stylesheet';
      link.href = `https://cdn.jsdelivr.net/npm/swiper@${SWIPER_VERSION}/swiper-bundle.min.css`;
      document.head.appendChild(link);
    }

    if (document.getElementById('swiper-bundle-js')) {
      const wait = setInterval(() => {
        if (typeof Swiper !== 'undefined') {
          clearInterval(wait);
          callback();
        }
      }, 50);
      return;
    }

    const script = document.createElement('script');
    script.id = 'swiper-bundle-js';
    script.src = `https://cdn.jsdelivr.net/npm/swiper@${SWIPER_VERSION}/swiper-bundle.min.js`;
    script.onload = callback;
    document.head.appendChild(script);
  };

  const initSlider = (slider) => {
    if (slider.swiper) return;

    const section = slider.closest('.shopify-section') || document;
    const slidesCount = slider.querySelectorAll('.swiper-slide').length;
    const hasMultipleSlides = slidesCount > 1;
    const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);
    const autoplayEnabled = slider.dataset.autoplay === 'true' && hasMultipleSlides && !isDesignMode;
    const autoplayDelay = parseInt(slider.dataset.autoplayDelay, 10) || 5000;

    new Swiper(slider, {
      loop: hasMultipleSlides,
      slidesPerView: 1,
      spaceBetween: 0,
      grabCursor: true,
      allowTouchMove: hasMultipleSlides,
      autoplay: autoplayEnabled
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : false,
      navigation: {
        prevEl: section.querySelector('.avel-banner-carousel__arrow--previous'),
        nextEl: section.querySelector('.avel-banner-carousel__arrow--next'),
      },
      pagination: {
        el: section.querySelector('.avel-banner-carousel__pagination'),
        clickable: true,
      },
    });
  };

  const init = () => {
    const sliders = document.querySelectorAll(SLIDER_SELECTOR);
    if (!sliders.length) return;

    loadSwiper(() => sliders.forEach(initSlider));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest('.avel-banner-carousel__slide');
    const slider = event.target.closest(SLIDER_SELECTOR);
    if (!slide || !slider || !slider.swiper) return;

    const index = Array.from(slider.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')).indexOf(slide);
    if (index > -1) slider.swiper.slideToLoop(index);
  });
})();

/* Avel image banners: grid on desktop, Swiper carousel on mobile */
(() => {
  const SLIDER_SELECTOR = '.avel-image-banners__slider';
  const SWIPER_VERSION = 12;
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const loadSwiper = (callback) => {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }

    if (!document.getElementById('swiper-bundle-css')) {
      const link = document.createElement('link');
      link.id = 'swiper-bundle-css';
      link.rel = 'stylesheet';
      link.href = `https://cdn.jsdelivr.net/npm/swiper@${SWIPER_VERSION}/swiper-bundle.min.css`;
      document.head.appendChild(link);
    }

    if (document.getElementById('swiper-bundle-js')) {
      const wait = setInterval(() => {
        if (typeof Swiper !== 'undefined') {
          clearInterval(wait);
          callback();
        }
      }, 50);
      return;
    }

    const script = document.createElement('script');
    script.id = 'swiper-bundle-js';
    script.src = `https://cdn.jsdelivr.net/npm/swiper@${SWIPER_VERSION}/swiper-bundle.min.js`;
    script.onload = callback;
    document.head.appendChild(script);
  };

  const initSlider = (slider) => {
    if (slider.swiper || !mobileQuery.matches) return;

    const wrapper = slider.querySelector('.avel-image-banners__items');
    const items = slider.querySelectorAll('.avel-image-banners__item');
    const pagination = slider.querySelector('.avel-image-banners__pagination');
    const hasMultipleSlides = items.length > 1;
    const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);
    const autoplayEnabled = slider.dataset.autoplay === 'true' && hasMultipleSlides && !isDesignMode;
    const autoplayDelay = parseInt(slider.dataset.autoplayDelay, 10) || 5000;

    slider.classList.add('swiper');
    wrapper.classList.add('swiper-wrapper');
    items.forEach((item) => item.classList.add('swiper-slide'));

    new Swiper(slider, {
      loop: hasMultipleSlides,
      slidesPerView: 1,
      spaceBetween: 0,
      grabCursor: true,
      allowTouchMove: hasMultipleSlides,
      autoplay: autoplayEnabled
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : false,
      navigation: {
        prevEl: slider.querySelector('.avel-image-banners__arrow--previous'),
        nextEl: slider.querySelector('.avel-image-banners__arrow--next'),
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
    });
  };

  const destroySlider = (slider) => {
    if (!slider.swiper) return;

    const pagination = slider.querySelector('.avel-image-banners__pagination');

    slider.swiper.destroy(true, true);
    slider.classList.remove('swiper', 'swiper-backface-hidden');
    slider.querySelector('.avel-image-banners__items')?.classList.remove('swiper-wrapper');
    slider.querySelectorAll('.avel-image-banners__item').forEach((item) => item.classList.remove('swiper-slide'));
    if (pagination) pagination.innerHTML = '';
  };

  const update = () => {
    const sliders = document.querySelectorAll(SLIDER_SELECTOR);
    if (!sliders.length) return;

    if (mobileQuery.matches) {
      loadSwiper(() => sliders.forEach(initSlider));
    } else {
      sliders.forEach(destroySlider);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }

  mobileQuery.addEventListener('change', update);
  document.addEventListener('shopify:section:load', update);

  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest('.avel-image-banners__item');
    const slider = event.target.closest(SLIDER_SELECTOR);
    if (!item || !slider || !slider.swiper) return;

    const index = Array.from(slider.querySelectorAll('.avel-image-banners__item:not(.swiper-slide-duplicate)')).indexOf(item);
    if (index > -1) slider.swiper.slideToLoop(index);
  });
})();